import { formatNumberLocale } from "../../../_utils"

export function getColumns(isPublisher:boolean) {
  const columns = [
      {
        name: 'Campaign name',
        key:'campaignName',
        selector: (row:any) => row.campaignName,
        sortable: true,
        wrap: true,
        searchable:true
      },
      {
          name: 'Network',
          key:'network',
          selector: (row:any) => row.network,
          sortable: true,
          wrap: true,
          searchable:true
      },
      {
        name:'Country',
        key:'country',
        selector: (row:any) => row.country,
        sortable: true,
        wrap: true,
        searchable:true
      },
      {
        name: 'Clicks',
        key:'totalClicks',
        format: (row:any) => formatNumberLocale(row.totalClicks, 0),
        selector: (row:any) => row.totalClicks,
        sortable: true,
        wrap: true
      },
      {
        name:'Transactions',
        key:'totalTransactions',
        format: (row:any) => formatNumberLocale(row.totalTransactions,0),
        selector: (row:any) => row.totalTransactions,
        sortable: true,
        wrap: true
      },
      {
        name:isPublisher ? 'Commission' : 'Cost',
        key:'totalCommission',
        format: (row:any) => formatNumberLocale(row.totalCommission, 1),
        selector: (row:any) => row.totalCommission,
        sortable: true,
        wrap: true,
      },
      ...(isPublisher ? [
      {
        name: 'Conversion rate',
        key:'conversionRate',
        format: (row:any) => `${formatNumberLocale(row.conversionRate, 1)}%`,
        selector: (row:any) => row.conversionRate,
        sortable: true,
        wrap: true
      },
      ] : [
        {
          name: 'Revenue',
          key: 'totalOrderAmount',
          format: (row:any) => formatNumberLocale(row.totalOrderAmount, 1),
          selector: (row:any) => row.totalOrderAmount,
          sortable: true,
          wrap: true,
          id:'totalOrderAmount'
        },
        {
        name: 'Conversion rate',
        key:'conversionRate',
        format: (row:any) => `${formatNumberLocale(row.conversionRate, 1)}%`,
        selector: (row:any) => row.conversionRate,
        sortable: true,
        wrap: true
        },
        {
          name: 'ROAS',
          key:'roas',
          format: (row:any) => `${formatNumberLocale(row.roas, 1)}`,
          selector: (row:any) => row.roas,
          sortable: true,
          wrap: true,
          width: '100px'
        },
        {
          name: 'CPC',
          key:'cpc',
          format: (row:any) => formatNumberLocale(row.cpc, 1),
          selector: (row:any) => row.cpc,
          sortable: true,
          wrap: true,
          width: '100px'
        }
      ]),
      {
        name: 'EPC',
        key:'epc',
        format: (row:any) => formatNumberLocale(row.epc, 1),
        selector: (row:any) => row.epc,
        sortable: true,
        wrap: true,
        width: '100px'
      }
  ]
  return columns
}
